import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import slider_image1 from '../../assets/Images/slidder_picture1.png'
import '../../../assets/styles/pages/homeCss/herosection.css'

import home_all_one from '../../../assets/images/homeImages/Group 5096 (2).png'
import AOS from 'aos'
import { Link } from 'react-router-dom'

const Main = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, [])
    return (
        <div>
            <section className='heroSection '>
                <Container fluid>
                    <Row className=''>
                        <Col data-aos='fade-right' md={6} lg={6} sm={12}>
                            <div className=' slide1-texts-div'>
                                <div className="center-item">
                                    <p className=' head-h1'>Oxyzn: One-Stop-Shop For Your Well-Being</p>
                                    <p className='herotext_p'>Over 255 live and on-demand events across 45+ <br />wellness categories by >80 world-class coaches,<br /> Oxyzn is the only platform your employees need to <br /> take care of their well-being and perform at their best!</p>
                                    <div className='home-btn-sec' >
                                        {/* <button type="button" className='hero-button-demo'>Request a demo</button> */}
                                        <Link to="https://calendly.com/oxyzn/meeting-with-oxyzn" target="_blank" className='hero-button-demo'>Request a demo</Link>
                                        <button className='hero-button'>Learn More</button>

                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col data-aos='fade-left' md={6} lg={6} sm={12}>
                            <img className='home-all-one-img' src={home_all_one} alt="" />
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}

export default Main
